import { render, staticRenderFns } from "./KPOnRequest.vue?vue&type=template&id=aa67ad3c&scoped=true&"
import script from "./KPOnRequest.vue?vue&type=script&lang=js&"
export * from "./KPOnRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa67ad3c",
  null
  
)

export default component.exports